import { Formik, Field } from "formik";
import React from "react";
import styled from "styled-components";
import { Button } from "./Button";
import FileUploader from "./FileUploader";
import Input from "./Input";
import { TitleText } from "./Text";
import Axios from "../utils/axios";
import { SCORECARD_URL } from "../api/urls";
import { get } from "../utils/get";
import { toast } from "react-toastify";
interface IProps {
  scorecardId: string;
  closeModal: any;
}
const DocumentUpload = ({ scorecardId, closeModal }: IProps) => {
  const handleFileUpload = (values) => {
    console.log(values);
    const payload = new FormData();
    payload.append("document_name", get(values, "name"));
    payload.append("document", get(values, "contract"));
    payload.append("notes", get(values, "notes"));
    payload.append("document_type", "performance_contract");
    Axios.post(`${SCORECARD_URL}/${scorecardId}/document`, payload)
      .then((res) => {
        toast.success("Contract uploaded successfully");
        closeModal(false);
      })
      .catch((err) => toast.error(err));
  };
  return (
    <div>
      <Formik
        initialValues={{ name: "", file: "" }}
        onSubmit={(values) => handleFileUpload(values)}
      >
        {({ setFieldValue, values, handleSubmit }) => (
          <FileUploadContainer>
            <Field
              name="name"
              type="text"
              label="Document Name"
              component={Input}
              width="90%"
              isBordered={true}
              placeholder="Name"
            />
            <Label>
              <Field
                type="file"
                name="contract"
                component={FileUploader}
                accept=".pdf"
                label="Performance contract"
                backgroundColor="#F5F6FB"
                width="90%"
              />
            </Label>

            <Field
              name="notes"
              type="textarea"
              label="Description"
              component={Input}
              height="6em"
              width="90%"
              isBordered={true}
              placeholder="Description"
            />
            <EditButton text="Done" onClick={() => handleSubmit()} />
          </FileUploadContainer>
        )}
      </Formik>
    </div>
  );
};

export default DocumentUpload;

const FileUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const EditButton = styled(Button)`
  width: 45%;
  padding: 0.5em 0.2em;
`;
const Label = styled.label`
  display: flex;
  flex-direction: column;
  color: #01A8CE;
  font-family: "Raleway", sans-serif;
  font-size: 0.8em;
  margin: 0.5em 0;
  position: relative;
`;
